import template from "./index.html";
import "./index.less";
import { EVENT_LOGOUT } from "../../../constants";

//remoteSupport
export function controller(config, $uibModal, $scope, eventBus) {
	const ctrl = this;

	ctrl.handleClose = handleClose;
	ctrl.onSupportClick = onSupportClick;
	ctrl.$onInit = onInit;
	ctrl.$onDestroy = handleClose;

	function onInit() {
		ctrl.support = config.support;
		eventBus.register(EVENT_LOGOUT, () => { handleClose(); }, $scope);
	}

	function handleClose() {
		ctrl.modalInstance.close();
	}

	function onSupportClick() {
		ctrl.modalInstance.close();

		$uibModal.open({
			component: "support-feedback"
		});
	}
}

export default angular
	.module("vesl.components.remote-support", [])
	.component("remoteSupport", {
		controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			showClose: "<"
		}
	}).name;
